import React from 'react';
import styled from 'styled-components';

export interface HighligherProps {
  q: string;
  text: string;
}

const Span = styled.span`
  line-height: 24px;
  .h {
    background-color: #E5E6FF;
  }
`;

const Highligher: React.FC<HighligherProps> = ({ text, q = '' }) => {
  if (!text) {
    return null;
  }

  if (q) {
    const re = new RegExp(q, 'ig');
    const nt = text.replace(re, (a) => `<span class="h">${a}</span>`);

    // eslint-disable-next-line react/no-danger
    return <Span dangerouslySetInnerHTML={{ __html: nt }} />;
  }

  return <Span>{text}</Span>;
};

export default Highligher;
